import { action, makeObservable } from 'mobx';
import { CreateBoxForm } from 'modules/product/forms';
import { BaseViewStore } from 'core/stores';
import { LookupStore } from 'modules/lookup/stores';
import { lookupRouteName, lookupNames, sourceOfChange } from 'common/constants';
import { formInvalidate } from 'core/utils';
import _ from 'lodash';

class CreateBoxViewStore extends BaseViewStore {
	form = new CreateBoxForm();

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.lookupStore = new LookupStore(this.rootStore);
	}

	@action.bound async createBox() {
		this.form.validate().then(async ({ isValid }) => {
			if (isValid) {
				this.suspend();
				try {
					const boxFormValues = this.form.values();
					const response = await this.lookupStore.createLookup(
						boxFormValues,
						lookupRouteName.box,
						sourceOfChange.createLookup
					);
					if (response.message) {
						this.form.invalidate(response.message);
					} else {
						var savedItem = this.lookupStore.item.box;
						this.rootStore.notificationStore.success([
							'LOOKUPCREATE.LOOKUP',
							{ name: savedItem.name, lookup: lookupNames.box },
						]);
						await this.modalParams.data.boxDropdownStore.reload();
						await this.modalParams.data.boxDropdownStore.setValue(savedItem);
						this.modalParams.success();
					}
				} catch (err) {
					this.form.showErrors(true);
					formInvalidate({ form: this.form, err });
				}
				this.resume();
			} else {
				this.form.showErrors(true);
			}
		});
	}
}

export default CreateBoxViewStore;
